// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EZYyG","container_video":"styles_container_video__6wzh7","video":"styles_video__E9omu","container_content":"styles_container_content__MMjw9"};